enum CancelationReasons {
  CanceledByCustomer = '0',
  InvalidCardType = '6',
  TechnicalIssue = '15',
  SsnNotVerified = '22'
}

export default CancelationReasons;
